import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ThemeSaveRequestDto } from '../../../store/landscapeAPI/theme/dto/request/theme-save-request.dto';
import { ThemeResponseDto } from '../../../store/landscapeAPI/theme/dto/response/theme-response.dto';
import { saveTheme } from '../../../store/landscapeAPI/theme/reducers/theme.slice';
import { AppDispatch, RootState } from '../../../store/store';
import { getUUID } from '../../../utils/UUID';
import Spinner from '../../atoms/Spinner/Spinner';
import { ReportingDetailsThemesAddTemplate } from '../../templates';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { MediaSaveResponseDto } from '../../../store/mediaAPI/media/dto/response/media-save-response';
import { saveMedia } from '../../../store/mediaAPI/media/reducers/media.slice';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

// import styles from './ReportingDetailsThemesAddPage.module.css';

interface ReportingDetailsThemesAddPageProps {}

const ReportingDetailsThemesAddPage: FC<
  ReportingDetailsThemesAddPageProps
> = () => {
  const [theme, setTheme] = useState<ThemeResponseDto>({
    name: '',
    description: '',
    icon: '',
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { status } = useSelector((state: RootState) => state.themeSlice);
  const { status: mediaStatus } = useSelector(
    (state: RootState) => state.mediaSlice
  );
  const [imageMeta, setImageMeta] = useState<ImageMeta>();

  const handleOnChange = (theme: ThemeResponseDto) => {
    setTheme(theme);
  };

  const handleImageOnChange = (imageMeta: ImageMeta) => {
    setImageMeta(imageMeta);
  };

  const handleAddTheme = async (theme: ThemeResponseDto) => {
    let icon: MediaSaveResponseDto = {
      href: '',
    };
    if (theme.icon && theme.icon !== '' && imageMeta) {
      const formData = new FormData();
      formData.append(
        'file',
        new Blob([theme.icon], {
          type: imageMeta?.imageType ?? 'image/png',
        }),
        imageMeta?.imageSrc
      );
      icon = (await dispatch(saveMedia(formData)))
        .payload as MediaSaveResponseDto;
    }
    const data: ThemeSaveRequestDto = {
      id: theme.id,
      name: theme.name,
      description: theme.description,
      icon: icon.href,
      published: theme.published,
    };

    const response = await dispatch(
      saveTheme({ saveRequest: data, language: selectedLanguage })
    );
    const newTheme = response.payload as ThemeResponseDto;

    navigate(`/reporting-details/themes/${newTheme.id}/edit`);
  };

  const [selectedLanguage, setLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [fromLanguage, setFromLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const [toLanguage, setToLanguage] = useState<LocalesLanguagesConstants>(
    LocalesLanguagesConstants.en
  );

  const generateAllTranslations: () => Promise<
    PromiseSettledResult<void>[]
  > = async () => {
    const rejectedResults: PromiseSettledResult<void>[] = [
      {
        status: 'rejected',
        reason: new Error(
          'Must save verification status before generating translation'
        ),
      },
    ];

    return Promise.reject(rejectedResults);
  };

  const generateTranslation = async () => {};

  if (status === 'loading' || mediaStatus === 'loading') {
    return <Spinner />;
  }

  return (
    <ReportingDetailsThemesAddTemplate
      data={theme}
      handleAddTheme={handleAddTheme}
      handleOnChange={handleOnChange}
      handleImageOnChange={handleImageOnChange}
      setLanguage={setLanguage}
      selectedLanguage={selectedLanguage}
      fromLanguage={fromLanguage}
      setFromLanguage={setFromLanguage}
      toLanguage={toLanguage}
      setToLanguage={setToLanguage}
      generateTranslation={generateTranslation}
      generateAllTranslations={generateAllTranslations}
    />
  );
};

export default ReportingDetailsThemesAddPage;
